<div class="login-container" role="dialog" aria-labelledby="login-title">
  <button type="button" class="login-close" (click)="close()" [attr.aria-label]="'generic.close' | translate">
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>

  <!-- Connexion / création de compte -->
  <section class="login-card">
    <h2 id="login-title" class="login-title">{{ 'popins.login.title' | translate }}</h2>
    <p class="login-text">{{ 'popins.login.text' | translate }}</p>
    <ng-casto-button class="primary" (click)="submit()" [label]="'popins.login.btn' | translate"></ng-casto-button>

    <hr class="login-separator" />

    <h3 class="login-subtitle">{{ 'popins.login.no-account' | translate }}</h3>
    <ng-casto-button
      class="secondary"
      (click)="subscribe()"
      [label]="'popins.login.create-account' | translate"></ng-casto-button>
  </section>

  <!-- Encart bleu : bénéfices du compte client -->
  <section class="login-benefits">
    @if (configuratorPreviews.length) {
      <div class="login-previews" aria-hidden="true">
        @for (preview of configuratorPreviews; track preview.src) {
          <img [src]="preview.src" [alt]="preview.alt" />
        }
      </div>
    }

    <div class="login-benefits-content">
      <h3 class="login-benefits-title">{{ 'popins.login.benefits.title' | translate }}</h3>
      <ul>
        <li>
          <fa-icon [icon]="faCheckCircle" aria-hidden="true"></fa-icon>
          <span>{{ 'popins.login.benefits.history' | translate }}</span>
        </li>
        <li>
          <fa-icon [icon]="faCheckCircle" aria-hidden="true"></fa-icon>
          <span>{{ 'popins.login.benefits.manage' | translate }}</span>
        </li>
      </ul>
    </div>
  </section>
</div>
